import { render, staticRenderFns } from "./VDraggableListItem.vue?vue&type=template&id=1fd3834e&scoped=true&"
import script from "./VDraggableListItem.vue?vue&type=script&lang=ts&"
export * from "./VDraggableListItem.vue?vue&type=script&lang=ts&"
import style0 from "./VDraggableListItem.vue?vue&type=style&index=0&id=1fd3834e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd3834e",
  null
  
)

export default component.exports